import TourEventApi from './TourEventApi';
export default TourEventApi;
